'use client'

import { SessionProvider } from 'next-auth/react'
import type { PropsWithChildren } from 'react'
import type { Session } from 'next-auth'
import { QueryProvider } from './QueryProvider'
import { Toaster } from '../overlay/Toaster'
import PlatformProvider from './PlatformProvider'
import { ErrorBoundary } from '../ErrorBoundary'
import { BootstrapRunner } from '@shared/core';
import { RUNTIME_REGISTRIES } from '../../../registries/browser';

if (typeof window !== 'undefined') {
  BootstrapRunner.runDetached(RUNTIME_REGISTRIES);
}

interface ProvidersProps extends PropsWithChildren {
  session?: Session | null;
}

export default function Providers({ children, session }: ProvidersProps) {
  return (
    <ErrorBoundary>
        <SessionProvider session={session}>
          <QueryProvider>
            <PlatformProvider>
              {children}
            </PlatformProvider>
            <Toaster />
          </QueryProvider>
        </SessionProvider>
    </ErrorBoundary>
  )
}


